import "./Profile.css";

import MasterButton, { ButtonLayoutType, ButtonSize, ButtonVariation } from "../../components/button/MasterButton";
import { LeftArrow }  from "../../assets/LeftArrow";

import { useNavigate } from "react-router-dom";

const Profile = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className="profile-page">
        <div className="tab-header">
          <div className="left-section">
            <div>
              <MasterButton
                options={{
                  layoutType: ButtonLayoutType.IconLabel,
                  size: ButtonSize.Small,
                  variation: ButtonVariation.Outlined,
                  label: "Back",
                  icon: <LeftArrow />,
                }}
                onClick={() => {
                  console.log("Unassign clicked");
                  navigate(-1);
                }}
              ></MasterButton>
            </div>
            
            <div className="title headline-small">Profile Settings</div>
          </div>
          
        </div>
        <div className="content">
          <div className="full-height">
          </div>
          
        </div>
      </div>
    </>
  );
};

export default Profile;
